import { useState } from 'react';
import { Title, Text } from '@recargas-dominicanas/core/components';
import { TableHeader } from '@recargas-dominicanas/core/components';
import { PageContainer } from '@recargas-dominicanas/core/components';
import { PageToolbar } from '@recargas-dominicanas/core/components';
import { PageContent } from '@recargas-dominicanas/core/components';
import { OutlineTable } from '@recargas-dominicanas/core/components';
import { BusinessItem } from './business-item/business-item.component';
import { BusinessStore } from '../../store/businessStore';
import { useAsyncEffect } from '@recargas-dominicanas/core/utils';
import { OptionButton } from '@recargas-dominicanas/core/components';
import { AddCustomerModal } from './add-customer-modal/add-customer-modal.component';
import { style } from './home.module.css';

export function Home() {

  const business = BusinessStore.getAll();
  const [openModal, setOpenModal] = useState(false);

  useAsyncEffect(async () => {
    await BusinessStore.fetchAll();
  });

  function handleAddButtonClick() {
    setOpenModal(true);
  }

  function handleCloseModal() {
    setOpenModal(false);
  }

  return (
    <PageContainer className={style.container}>
      <PageToolbar className={style.toolbar}>
        <Title style={style.title} title='Clientes'/>
        <OptionButton
          icon='add_business'
          title='Agregar cliente'
          onClick={handleAddButtonClick}/>
      </PageToolbar>
      <PageContent className={style.content}>
        <OutlineTable style={style.table}>
          <TableHeader style={style.tableHeader}>
            <Text text='ID'/>
            <Text text='Negocio'/>
            <Text text='Propietario'/>
            <Text text='Teléfono'/>
            <Text text='Ciudad'/>
            <Text text='Estado'/>
            <Text text='Balance'/>
            <Text text='Ventas'/>
            <span></span>
          </TableHeader>
          <tbody>
            {
              business?.map(business => (
                <BusinessItem 
                  key={business.id}
                  business={business}/>
              ))
            }
          </tbody>
        </OutlineTable>
      </PageContent>
      <AddCustomerModal 
        open={openModal}
        onClose={handleCloseModal}/>
    </PageContainer>
  );
}
